import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";

class CourseFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false
        };
    }

    toggleCompany(e) {
        this.props.handleChange(e);
        this.state.showCompany = ! this.state.showCompany;
    }

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            isEdit
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            autoComplete={false}
                            name="name_short"
                            label={i18n.get('courses.name_short')}
                            // label_exclaim={i18n.get('courses.name_short_explain')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name_short}
                            error={errors.name_short}
                            touched={touched.name_short}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {/*Divider*/}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormField
                            type="text"
                            name="name"
                            label={i18n.get('courses.name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            error={errors.name}
                            touched={touched.name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormField
                            type="text"
                            name="seminar"
                            label={i18n.get('courses.seminar')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.seminar}
                            error={errors.seminar}
                            touched={touched.seminar}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={2}>
                        <FormDate
                            type="date"
                            name="start"
                            label={i18n.get('courses.start')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.start}
                            error={errors.start}
                            touched={touched.start}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormDate
                            type="date"
                            name="end"
                            label={i18n.get('courses.end')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.end}
                            error={errors.end}
                            touched={touched.end}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        {/*<FormField*/}
                            {/*type="text"*/}
                            {/*name="duration"*/}
                            {/*label={i18n.get('courses.duration')}*/}
                            {/*onChange={handleChange}*/}
                            {/*onBlur={handleBlur}*/}
                            {/*value={values.duration}*/}
                            {/*error={errors.duration}*/}
                            {/*touched={touched.duration}*/}
                        {/*/>*/}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormAutocomplete
                            name="qualification_id"
                            label={i18n.get('persons.qualification')}
                            url="/search-qualification"
                            onChange={option => {
                                values.qualification_id = option.value;
                                if ( option.entity ) {
                                    values.qualification = option.entity
                                }
                                setFormikState({values});
                            }}
                            onBlur={handleBlur}
                            defaultOptions={values.qualification && [{
                                'value': values.qualification.id,
                                'label': values.qualification.name,
                                'entity': values.qualification,
                            }]}
                            value={values.qualification && {
                                'value': values.qualification.id,
                                'label': values.qualification.name,
                                'entity': values.qualification,
                            }}
                            error={errors.qualification_id}
                        />
                    </Grid>
                    {/*<Grid item xs={12} sm={2}>*/}
                        {/*<FormField*/}
                            {/*type="number"*/}
                            {/*name="max_participants"*/}
                            {/*label={i18n.get('courses.max_participants')}*/}
                            {/*onChange={handleChange}*/}
                            {/*onBlur={handleBlur}*/}
                            {/*value={values.max_participants}*/}
                            {/*error={errors.max_participants}*/}
                            {/*touched={touched.max_participants}*/}
                        {/*/>*/}
                    {/*</Grid>*/}
                    {/*<Grid item xs={12} sm={4}>*/}
                        {/*<FormField*/}
                            {/*type="text"*/}
                            {/*name="lecturer"*/}
                            {/*label={i18n.get('courses.lecturer')}*/}
                            {/*onChange={handleChange}*/}
                            {/*onBlur={handleBlur}*/}
                            {/*value={values.lecturer}*/}
                        {/*/>*/}
                    {/*</Grid>*/}
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/courses/${values.id}`}
                                confirmMessage={i18n.get('courses.confirm_message')}
                                successMessage={i18n.get('courses.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('courses.update') : i18n.get('courses.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default CourseFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Courses/CourseFormFields.js